<template>
  <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
    <v-layout row wrap>
      <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important">
        <!--Row #1-->
        <v-layout row wrap>
          <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;padding-bottom:0px;">
            <div style="padding-top:23px;font-weight:bolder;font-size:20px">مدیریت اخبار</div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md12 lg12 xl12 style="padding:0px;padding-bottom:2px !important">
        <v-card>
          <v-card-title></v-card-title>
          <v-card-text>
            <v-stepper non-linear v-model="NewProductStep">
              <v-stepper-header style="background-color:#262d47;color:orange">
                <v-stepper-step
                  editable
                  edit-icon="fa fa-check"
                  color="orange"
                  :complete="NewProductStep > 1"
                  step="1"
                >
                  &nbsp;
                  <span style="color:orange">اطلاعات پایه</span> &nbsp;
                </v-stepper-step>
                <v-stepper-step
                  editable
                  edit-icon="fa fa-check"
                  color="orange"
                  :complete="NewProductStep > 2"
                  step="2"
                >
                  &nbsp;
                  <span style="color:orange">چندرسانه ای</span> &nbsp;
                </v-stepper-step>
                <v-stepper-step
                  edit-icon="fa fa-check"
                  editable
                  color="orange"
                  :complete="NewProductStep > 3"
                  step="3"
                >
                  &nbsp;
                  <span style="color:orange">محتوی</span> &nbsp;
                </v-stepper-step>
              </v-stepper-header>
              <v-stepper-content step="1"><!--News Base Information-->
                <v-form ref="PrdBaseInfo">
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px;">
                      
                      <v-autocomplete
                        outlined
                        dense
                        no-data-text="دسته بندی یافت نشد"
                        color="#2a2d45"
                        item-text="nC_Title"
                        item-value="nC_Id"
                        :items="NoticesCategoryItems"
                        v-model="newsCat"
                        label="دسته بندی  "
                        :loading="isLoadingCatItems"
                      ></v-autocomplete>
                       
                      
                      <v-text-field color="#2a2d45" v-model="newsTitle" outlined dense label="عنوان خبر "></v-text-field>

                      <v-text-field color="#2a2d45" v-model="newsSup" outlined dense label=" روتیتر "></v-text-field>
                      <v-text-field
                        id="newsdate"
                        v-model="date"
                        color="#2a2d45"
                        outlined
                        dense
                        label=" تاریخ خبر "
                        readonly
                      ></v-text-field>
                      
                      <date-picker element="newsdate" color="#2a2d45" v-model="date"></date-picker>

                      <f-up :OldFile="CatImageName" @RetunedFileName="CatImageName = $event" Root="NOTICEIMAGE" Folder="NEWSIMAGE" BtnTitle="عکس اصلی"></f-up> 



                      
                      <v-row>
                        <v-col cols="8">خبر اسلایدی :</v-col>
                        <v-col cols="4" style="display: flex;justify-content: flex-end;">
                          <v-switch
                            v-model="NewsType"
                            style="padding-top:0px !important;margin-top:0px !important"
                            color="#2a2d45"
                          ></v-switch>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="8">وضعیت :</v-col>
                        <v-col cols="4" style="display: flex;justify-content: flex-end;">
                          <v-switch
                            v-model="newsStatus"
                            style="padding-top:0px !important;margin-top:0px !important"
                            color="#2a2d45"
                          ></v-switch>
                        </v-col>
                      </v-row>
                      <v-btn color="blue darken-2" @click="NewProductStep++" dark>
                        بعدی
                        <v-icon style="padding-right:15px;" small>fas fa-chevron-left</v-icon>
                      </v-btn>
                      
                    </v-flex>
                    <v-flex xs12 sm12 md8 lg8 xl8 style="padding:20px;">
                      <seo-form FileLoc="PRDCATSEOIMG" :Seo="PrdSeoModel" @SeoData="SeoChanged"></seo-form>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-stepper-content>
              <v-stepper-content step="2"><!--News Media Information-->
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                    <div>
                      عکس بنری خبر :
                    </div>
                    <f-up :OldFile="NewsBannerImage" @RetunedFileName="NewsBannerImage = $event" Root="NOTICEIMAGE" Folder="NEWSIMAGE" BtnTitle="عکس بنری"></f-up> 

                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                    <v-layout row wrap slot="extension">
                      <v-flex xs4 sm4 md4 lg4 x4 style="padding:20px">نوع فایل :</v-flex>
                      <v-flex xs3 sm3 md3 lg3 xl3 style="padding:20px">
                        <v-btn-toggle v-model="toggleMediaType" color="primary" dense group>
                          <v-btn :value="1" text>
                            <v-icon>fas fa-video</v-icon>
                          </v-btn>
                          <v-btn :value="2" text>
                            <v-icon>fas fa-image</v-icon>
                          </v-btn>
                        </v-btn-toggle>
                      </v-flex>
                      <v-flex xs5 sm5 md5 lg5 xl5 style="padding:20px"></v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                    <v-text-field v-model="videoItem" label="آیدی ویدئو آپارات" color="#2a2d45" outlined dense></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px;">
                    <div class="text-align:center">
                      <v-btn color="baseColor" @click="NewProductStep--" dark>
                        <v-icon style="padding-left:15px;" small>fas fa-chevron-right</v-icon>قبلی
                      </v-btn>&nbsp;
                      <v-btn color="blue darken-2" @click="NewProductStep++" dark>
                        بعدی
                        <v-icon style="padding-right:15px;" small>fas fa-chevron-left</v-icon>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-stepper-content>
              <v-stepper-content step="3"><!--News Content Information-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md6 lg6 xl6 style="padding:20px">
                      <div>خلاصه خبر :</div>
                      <quill-editor :content="vNewsSummary"
                                    @change="({html})=>{vNewsSummary = html}">
                                    </quill-editor>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6 xl6 style="padding:20px">
                      <div>محتوی اصلی خبر :</div>
                      <quill-editor :content="vNewsContent"
                                    @change="({html})=>{vNewsContent = html}">
                                    </quill-editor>
                    </v-flex>
                    <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px;">
                        <div class="text-align:center">
                            <v-btn color="baseColor" @click="NewProductStep--" dark>
                                <v-icon style="padding-left:15px;" small>fas fa-chevron-right</v-icon>قبلی
                            </v-btn>&nbsp;
                            <v-btn @click="registerNotices" outlined dark color="blue">
                                <v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره
                            </v-btn>
                        </div>
                    </v-flex>
                </v-layout>
              </v-stepper-content>
            </v-stepper>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12 style="padding:15px;">
        <div class="operationBoxDesign">
          <v-btn class="operationBoxButton" outlined color="#2a2d45" dark>
            <v-icon small style="padding-left:5px;">fa fa-file-export</v-icon>&nbsp;دریافت اکسل
          </v-btn>
        </div>
        
        <v-card style="margin-top:5px;">
            <h3 style="display:block;padding-right:10px;padding-top:20px;box-sizing:border-box">جستجو</h3>
           <v-card-title>
                <v-layout row wrap>
                    <v-flex xs12 sm6 md3 lg3 xl3 style="padding:20px">
                        <v-text-field color="#2a2d45" v-model="newsTitle" outlined dense label="عنوان خبر "></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3 lg3 xl3 style="padding:20px">
                        <v-autocomplete
                        outlined
                        dense
                        no-data-text="دسته بندی یافت نشد"
                        color="#2a2d45"
                        item-text="nC_Title"
                        item-value="nC_Id"
                        :items="NoticesCategoryItems"
                        v-model="newsCat"
                        label="دسته بندی  "
                        :loading="isLoadingCatItems"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 md3 lg3 xl3 style="padding:20px">
                        <v-row>
                            <v-col cols="5">
                                <date-picker element="filternoticesd" color="#2a2d45" v-model="date"></date-picker>
                                <v-text-field
                                id="filternoticesd"
                                v-model="date"
                                color="#2a2d45"
                                outlined
                                dense
                                label="  از تاریخ "
                                readonly
                                ></v-text-field>
                            </v-col>
                            <v-col cols="5">
                                <date-picker element="filternoticeed" color="#2a2d45" v-model="date"></date-picker>
                                <v-text-field
                                id="filternoticeed"
                                v-model="date"
                                color="#2a2d45"
                                outlined
                                dense
                                label=" تا تاریخ  "
                                readonly
                                ></v-text-field>
                            </v-col>
                            <v-col cols="1">
                                <v-btn  text dark color="blue" >
                                    <v-icon small style="padding-left:5px;">fa fa-search</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-flex>
                    <v-flex xs12 sm6 md3 lg3 xl3 style="padding:20px">
                        <v-row>
                            <v-col cols="8">وضعیت :</v-col>
                            <v-col cols="4" style="display: flex;justify-content: flex-end;">
                            <v-switch
                                v-model="newsStatus"
                                style="padding-top:0px !important;margin-top:0px !important"
                                color="#2a2d45"
                            ></v-switch>
                            </v-col>
                        </v-row>  
                    </v-flex>
                    <v-flex xs12 sm12 md12 xl12 lg12 style="padding:20px;">
                        <v-data-table :loading="isLoadingNotices" loading-text="در حال بارگزاری داده ها ، لطفا صبر کنید..." :items="noticesTableItems" :headers="noticesTableHeader" items-per-page-text="تعداد در هر صفحه" no-data-text="رکوردی یافت نشد" no-results-text="رکوردی یافت نشد" :footer-props="{'items-per-page-text':'آیتم در هر صفحه :','items-per-page-all-text':'همه'}">
                            <template v-slot:[`item.n_Status`]="{ item }">
                               <v-btn small text color="#D32F2F" @click="ActiveItem(item.n_Id)" dark v-if="!item.n_Status">غیر فعال</v-btn>
                               <v-btn small text color="#2E7D32" @click="DisableItem(item.n_Id)" dark v-else> فعال</v-btn>
                            </template>
                            <template v-slot:[`item.n_Image`]="{ item }">
                                <v-btn target="_blank" :href="newsMainImageUrl+`${item.n_Image}`" icon small><v-icon small>fas fa-eye</v-icon></v-btn>
                            </template>
                            <template v-slot:[`item.operation`]="{ item }">
                                <v-btn text icon small color="blue accent-4" @click="editItem(item)"><v-icon small>fas fa-edit</v-icon></v-btn>
                                <v-btn text icon small color="red accent-4" @click="confirmDeleteItem(item.n_Id)"><v-icon small>fas fa-trash</v-icon></v-btn>&nbsp;
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
           </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    <template>
      <!--Loading Dialog-->
      <div class="vld-parent">
        <loading
          color="#f75314"
          :width="parseInt(45)"
          :height="parseInt(45)"
          background-color="#fff"
          :active.sync="isLoading"
          :is-full-page="true"
        ></loading>
      </div>
    </template>
    <template>
        <v-dialog v-model="SelectNoticesImageChild" max-width="500">
            <v-card>
                <v-card-text style="padding-top:10px;">
                    <imgeditor @SavedFileName="PickImageName" :UploadUrl="UploadNoticeGalleryChildUrl" :FileLoc="UploadVideoDirectory"></imgeditor>
                </v-card-text>
            </v-card>
        </v-dialog>
    </template>
            <template><!--Delete Confirm Dialog-->
            <v-dialog max-width="450" persistent v-model="ConfirmItemDeleteDialog">
                <v-card>
                    <v-card-title style="padding:0px !important">
                        <v-app-bar dense color="rgb(42, 45, 69)" dark>
                            <v-toolbar-title style="color:orange">حذف دائمی</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon color="orange" @click="ConfirmItemDeleteDialog = false" small>fa fa-times</v-icon>
                        </v-app-bar>
                    </v-card-title>
                    <v-card-text style="padding-top:15px;">
                        <v-alert type="error" outlined>
                            کاربر گرامی ؛ رکورد مورد نظر به صورت دائمی حذف خواهند شد.ادامه میدهید؟
                        </v-alert>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn outlined :loading="deleteBtnLoading" color="error" @click="DeleteItem"><v-icon small style="padding-left:5px;">fa fa-trash</v-icon>&nbsp; بله</v-btn>&nbsp;
                        <v-btn outlined @click="ConfirmItemDeleteDialog = false" color="info"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp; خیر</v-btn>&nbsp;
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>

  </div>
</template>
<script>
const axios = require("axios");
const ApiUrl = require("../../constant/apiurl");
const MSGHNDL = require("../../constant/MessageHandler");
const FTYPES = require("../../constant/setting/Default/AllowedFileTypes");
const FSIZE = require("../../constant/setting/Default/AllowedFileSize");
import { mapState, mapMutations, mapActions } from 'vuex'
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import JsonExcel from "vue-json-excel";
const moment = require("jalali-moment");
import { VueEditor } from "vue2-editor";
export default {
  name: "news",
  components: {
    Loading,
    JsonExcel,
    VueEditor
  },
  data: () => ({
    noticesTableHeader:
    [
        {text:"#",value:"counter",sortable:true,align:"right"},
        {text:"دسته بندی ",value:"n_CatTitle",sortable:true,align:"right"},
        {text:"عنوان ",value:"n_Title",sortable:true,align:"right"},
        {text:"تاریخ خبر",value:"n_ShamsiDate",sortable:true,align:"right"},
        {text:"عکس",value:"n_Image",sortable:true,align:"right"},
        {text:"وضعیت",value:"n_Status",sortable:true,align:"right"},
        {text:"عملیات",value:"operation",sortable:true,align:"right"},
    ],
    isLoading: false,
    menu: false,
    date: "",
    catLogoSelectionDialog: false,
    CatSelectionModels: [],
    NewProdCatModels: [],
    CategoryItems: {
      cat1: [],
      cat2: [],
      cat3: [],
      cat4: [],
      cat5: [],
      cat6: [],
      cat7: [],
      cat8: [],
      cat9: [],
      cat10: [],
      cat11: [],
      cat12: [],
      cat13: [],
      cat14: [],
      cat15: [],
      cat16: [],
      cat17: [],
      cat18: [],
      cat19: [],
      cat20: []
    },
    catLogoData: require("../../assets/logo.png"),
    NoticesCategoryItems: [],
    NewProductDialog: false,
    inEditingItem: false,
    NewProductStep: 1,
    PrdSeoModel: {},
    seo: "",
    BrandItems: [],
    ALLOEWDIMGSIZE: {},
    LabelItems: [],
    ProdStatus: false,
    toggleMediaType: 2,
    videoSrc: "",
    inUploading: false,
    imageItems: [],
    selectedLogoSource: "",
    uploadVideoPath: "",
    videoUploadProgress: 0,
    UploadVideoDirectory: "NEWSMEDIA",
    SelectNoticesImageChild:false,
    UploadNoticeGalleryChildUrl:"",
    NewsSummary:"خلاصه خبر",
    vNewsSummary:null,
    vNewsContent :null,
    NewsContent:"محتوای اصلی خبر",
    newsCat:"",
    NewsType:false,
    newsTitle:"",
    newsSup:"",
    newsStatus:true,
    isLoadingCatItems:false,
    selectedNoticeId:0,
    noticesTableItems:[],
    isLoadingNotices:false,
    originalItems:[],
    newsMainImageUrl:"",
    isSliderNews:1,
    SeoData:{
            title:"",
            url:"",
            keywords:"",
            image:"",
            description:"",
            othermeta:""
        },
      uploadNewsImageUrl:"",
      NewsBannerImage:"",
     
      ConfirmItemDeleteDialog:false,
      deleteItemId:0,
      deleteBtnLoading:false,
      productCategory:0
  }),
  async created() {
    let vm = this;
    // vm.LogoUrl = ApiUrl.PcLogo;
    vm.uploadNewsImageUrl = ApiUrl.uploadNoticesImage;

     vm.newsMainImageUrl = ApiUrl.NewsMainImage;
    vm.UploadedVideoPath = ApiUrl.NewsMedia;
    vm.uploadVideoPath = ApiUrl.uploadNoticesVideo;
    vm.UploadNoticeGalleryChildUrl = ApiUrl.uploadNoticesGalleryChild;
    axios.interceptors.request.use(
      config => {
        vm.isLoading = true;
        return config;
      },
      error => {
        vm.isLoading = false;
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      response => {
        vm.isLoading = false;
        return response;
      },
      error => {
        vm.isLoading = false;
        return Promise.reject(error);
      }
    );
    this.ALLOEWDIMGSIZE = FSIZE.PRDCATIMGSIZE;
    await vm.loadGalleryCatCombo();
  },
  computed:{
    LANG(){
      return this.$store.getters.GetLang;
    }
  },
  watch:{
    LANG(nL,oL){
      alert("Language Changed "+nL);
    }
  },

  methods: {
    ...mapActions([                  // Add this
      'setSeoForm'
      ]),
     
    LoadSeoFormData()
    {
        let vm = this;

        return vm.seo;
       
    },
            async DeleteItem()
        {
            let vm = this;
            vm.deleteBtnLoading = true;
            let Model = {};
            Model.N_Id = vm.deleteItemId;
            await axios.post(ApiUrl.DeleteNotices,Model)
            .then(async (res)=>{
                vm.deleteBtnLoading = false;
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    vm.ConfirmItemDeleteDialog = false;
                    await vm.loadNotices();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                vm.deleteBtnLoading = false;
                MSGHNDL.ERR(err);
            });
        },

    confirmDeleteItem(id)
        {
            let vm = this;
            vm.ConfirmItemDeleteDialog = true;
            vm.deleteItemId = id;
    },
    async ActiveItem(id)
        {
            let vm = this;
            let Model = {};
            Model.N_Id = id;
            await axios.post(ApiUrl.ActiveNotices,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadNotices();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        async DisableItem(id)
        {
            let vm = this;
            let Model = {};
            Model.N_Id = id;
            await axios.post(ApiUrl.DisableNotices,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadNotices();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },

    editItem(item)
    {
        let vm = this;
        console.warn(item);
        vm.selectedNoticeId = item.n_Id;
        vm.newsCat = item.n_CId;
        vm.newsTitle = item.n_Title;
        vm.NewsType = item.n_IsSlideShow;
        vm.newsSup = item.n_Sup;
        vm.date = item.n_ShamsiDate;
        vm.CatImageName = item.n_Image;
        vm.catLogoData = vm.newsMainImageUrl+item.n_Image;
        vm.PrdSeoModel = JSON.parse(item.n_Seo);
        vm.setSeoForm(JSON.parse(item.n_Seo));
        vm.date = item.n_ShamsiDate;
        vm.toggleMediaType = item.n_MediaType;
        vm.NewsBannerImage = item.n_BannerImage;
        vm.vNewsSummary = item.n_Summary;
        vm.NewsContent = item.n_Summary;
        vm.vNewsContent = item.n_Content;
        vm.NewsSummary = item.n_Content;
        vm.videoItem = item.n_Media;
        vm.inEditingItem = true;
    },
    cancelEditItem()
    {
        let vm = this;
        vm.newsCat = "";
        vm.newsTitle = "";
        vm.NewsType = 1;
        vm.newsSup = "";
        vm.date = "";
        vm.newsStatus = true;
        vm.CatImageName = "";
        vm.vNewsSummary = null ;
        vm.vNewsContent = null;
        vm.PrdSeoModel = {
            title:"",
            url:"",
            keywords:"",
            image:"",
            description:"",
            othermeta:""
        };
        vm.toggleMediaType = 2;
        vm.videoItem = "";
        vm.imageItems = [];
        vm.NewsSummary = "خلاصه خبر";
        vm.NewsContent = "محتوی خبر";
        vm.inEditingItem = false;
        vm.NewsBannerImage = "";
    },
    async registerNotices()
    {
            let vm = this;
            let Model = {};
            Model.N_Type = 1;
            Model.N_CId = vm.newsCat;
            Model.N_Title = vm.newsTitle;
            Model.N_IsSlideShow = vm.NewsType;
            let seo = vm.LoadSeoFormData();
            Model.N_Sup = vm.newsSup;
            Model.N_ShamsiDate = vm.date;
            Model.N_Status = vm.newsStatus;
            Model.N_Image = vm.CatImageName;
            Model.N_BannerImage = vm.NewsBannerImage;
            Model.N_Seo = JSON.stringify(seo);
            Model.N_MediaType = vm.toggleMediaType ;
            Model.ProductCatId = vm.productCategory;
           
                Model.N_Media = vm.videoItem;
          
            Model.N_Summary = vm.vNewsSummary;
            Model.N_Content = vm.vNewsContent;
            Model.N_Url = seo.url;
            Model.Lang = vm.LANG;
            var url = ApiUrl.registerNotices;
            if(vm.inEditingItem)
            {
                Model.N_Id = vm.selectedNoticeId;
                url = ApiUrl.updateNotices;
            }
            await axios.post(url,Model).then(async (res)=>{
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.loadNotices();
                     vm.cancelEditItem();
                    MSGHNDL.OK(data.msg);
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            }).catch((err)=>{console.warn(err)});
    },
    async loadNotices()
    {
        let vm = this;
        vm.isLoadingNotices = true;
        await axios.post(ApiUrl.LoadNotices+'/1/'+vm.LANG).then((res)=>{
            vm.isLoadingNotices = false;
            let data = res.data;
            console.warn(data);
            if(data.status)
            {
                vm.noticesTableItems = data.data;
                vm.originalItems = data.data;
                console.warn(data.data);
                
            }
        }).catch((err)=>{
            vm.isLoadingNotices = false;
            console.error(err);
        });
    },
    async deleteImageItem(item)
    {
        let vm = this;
        vm.imageItems = vm.imageItems.filter(i => i !== item);
        await axios
        .post(ApiUrl.removeNoticesGalleryChild, {
          DataUrl: item,
          Loc: vm.UploadVideoDirectory
        })
        .then(res => {
          if (res.data.status) {
            MSGHNDL.OK(res.data.msg);
            vm.imageItems = vm.imageItems.filter(i => i !== item);
          } else {
            MSGHNDL.ERR(res.data.msg);
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    PickImageName(fname)
    {
       this.imageItems.push(fname);
    },
    PickVideoName(fname) {
      this.videoItem = fname;
    },
    async loadGalleryCatCombo()
    {
        let vm = this;
        vm.isLoadingCatItems = true;

        await axios.post(ApiUrl.LoadNoticesCatCombo+'/1/'+vm.LANG).then(async (res)=>{
            vm.isLoadingCatItems = false;
            let data = res.data;
            console.warn(data);
            if(data.status)
            {
                vm.NoticesCategoryItems = data.data;
                setTimeout(async () => {
                    await vm.loadNotices();
                }, 1000);
            }
        }).catch((err)=>{
            vm.isLoadingCatItems = false;
            console.error(err);
        });
    },
    async uploadEntityLogo() {
      let vm = this;
      await axios
        .post(ApiUrl.uploadNoticesImage, {
          DataUrl: vm.catLogoData,
          Loc: "NEWSIMAGE"
        })
        .then(res => {
          if (res.data.status) {
            MSGHNDL.OK(res.data.msg);
            vm.CatImageName = res.data.data;
            vm.catLogoSelectionDialog = false;
          } else {
            MSGHNDL.ERR(res.data.msg);
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    catLogoSelectedEvt(e) {
      let vm = this;
      let file = e.target.files[0];
      if (FTYPES.PRDCATLOGOFILETYPES.indexOf(file.type) == -1) {
        MSGHNDL.ERRFILEFORMAT();
        e.preventDefault();
        return;
      }
      if (file.size > 2000000) {
        MSGHNDL.ERRFILESIZE("2 مگابایت ");
        e.preventDefault();
        return;
      }
      MSGHNDL.CHKIMAGESIZE(file, 0, 0, 0, 0, 1);

      if (FileReader) {
        var fr = new FileReader();
        fr.onload = function() {
          vm.selectedLogoSource = fr.result;
          vm.catLogoSelectionDialog = true;
        };
        fr.readAsDataURL(file);
      }
    },
    change({ coordinates, canvas }) {
      this.catLogoData = canvas.toDataURL();
    },
    shamsiDate() {
      return this.changeDate(this.date);
    },
    changeDate(d) {
      return moment(d, "YYYY/MM/DD")
        .locale("fa")
        .format("YYYY/MM/DD");
    },
    SeoChanged(data) {
      this.seo = data;
    }
  }
};
</script>
<style>
.v-stepper__step--inactive .v-stepper__label {
  color: rgba(255, 255, 255, 0.13) !important;
}
.theme--light.v-stepper
  .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error)
  .v-stepper__step__step {
  background: rgb(57, 64, 88) !important;
}
.operationBoxButton,
.OperationBoxColumns {
  margin-right: 5px;
}
.OperationBoxColumns {
  max-width: 200px;
  display: flex;
  align-items: center;
  padding-top: 10px;
}
.operationBoxDesign {
  display: flex;
  align-items: center;
  border-radius: 0px;
  justify-content: start;
  min-height: 50px;
  width: 100%;
  padding-right: 10px;
  padding-left: 10px;
  /* border: 1px solid rgb(207, 207, 207); */
  background-color: #fff;
  box-shadow: 0px 0px 4px rgba(207, 207, 207, 0.5);
}
</style>